import { IStoreApiState } from './api.interface'

export default {
  apiAbortControllerArray: [],
  apiXhrInstances: [],
  pendingAxiosRequests: {},
  pendingXhrRequests: {},
} as IStoreApiState
